import {Fragment, useRef, useState, useEffect} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import '../../assets/fontawesome-free-5.15.2-web/css/all.css'
import {useGlobalState} from "../../GlobalStateProvider";

const Thumb: (props: any) => JSX.Element = (props: any) => {

    const [checked, setChecked] = useState<boolean>(false);
    const input = useRef<HTMLInputElement>(null);
    const {onClick, identifier, parentProperties, properties, index, parentIndex} = props;

    const {state, setState} = useGlobalState();

    const isInSummary = (): boolean => {
        return state.summary.some((item) => item.identifier === identifier);
    }

    const handleClick = () => {
        if(onClick) {
            onClick();
        }
        setChecked(!checked);

        if (isInSummary()) {
            const updatedSummary = state.summary.filter((item) => item.identifier !== identifier);
            setState({ ...state, summary: updatedSummary });
        } else {
            const updatedSummary = [...state.summary, { index: parentIndex, identifier: identifier, title: properties.title, parentTitle: parentProperties.title, basePrice: properties.basePrice, calculation: {calculationValue: properties.calculationValue, calculationType: properties.calculationType, percentage: properties.percentage} }];
            setState({ ...state, summary: updatedSummary });
        }
    }

    const calculateIndex = () => {
        return String.fromCharCode(96 + (index + 1));
    }

    useEffect(() => {
        if(isInSummary()) {
            setChecked(true);
        }
        const buttons = document.querySelectorAll('.check-button');
        if(buttons.length > 0 ) {
            buttons.forEach((el: any) => {
                el.addEventListener('mouseover', () => {
                    const annotationInput = document.getElementById('annotationInput') as HTMLInputElement;
                    if(annotationInput) {
                        annotationInput.blur();
                    }
                });
            });
        }
    }, []);

    useEffect(() => {
        const checkedItems = document.querySelectorAll('.checked');
        const buttons = document.querySelectorAll('.check-button');
        if(checkedItems.length > 0) {
            if(buttons.length > 0 ) {
                buttons.forEach((el: any) => {
                    const isChecked = el.classList.contains('checked');
                    el.classList.remove('pointer-events-none')
                    if(!isChecked) {
                        el.classList.add('pointer-events-none')
                    }
                });
            }
        } else {
            if(buttons.length > 0 ) {
                buttons.forEach((el: any) => {
                    el.classList.remove('pointer-events-none')
                });
            }
        }
    }, [checked]);

    return (
        <Fragment>
            <button type="button" className={`group overflow-hidden ${properties.layout === 'row' ? 'w-[100%]' : 'lg:w-[420px] aspect-square'} ${checked ? 'checked' : ''} check-button transition-all bg-white border-[1px] border-gray-500 text-gray-500 hover:border-grey-500 hover:text-gray-500`} onClick={() => handleClick()} >
                {properties.layout === 'row' ?
                    <div className="relative w-full h-full">
                        <div className="flex flex-row items-center">
                            <div className="hidden lg:block px-5 uppercase border-r-[1px] border-r-gray-500 group-hover:border-r-gray-500 text-[12px] min-w-[50px]">
                                {calculateIndex()}
                            </div>
                            <div className="w-full uppercase text-start text-[12px] lg:text-[18px] p-3 px-5">{properties.title}</div>
                            <div className={`absolute top-[50%] ${checked ? 'bg-pomegranate-950 text-white' : 'bg-pomegranate-100 text-pomegranate-950'} w-[30px] h-[30px] mt-[-15px] ms-[-15px] lg:ms-0 left-auto right-0 me-[6px] lg:me-[15px] z-50 flex items-center justify-center rounded-full drop-shadow transition-all`} >
                                {checked &&
                                    <FontAwesomeIcon icon={icon({name: 'check'})} />
                                }
                            </div>
                        </div>
                    </div>
                    :
                    <div className="relative w-full h-full">

                        <div
                            className="hidden lg:block absolute left-0 top-0 px-4 py-2 ms-1 mt-2 uppercase border-r-[1px] border-r-gray-500 group-hover:border-r-gray-500 z-50 text-[12px]">
                            {calculateIndex()}
                        </div>

                        <div
                            className={`absolute top-0 lg:top-[50%] ${checked ? 'bg-pomegranate-950 text-white' : 'bg-pomegranate-100 text-pomegranate-950'} w-[30px] h-[30px] mt-[15px] lg:mt-[-15px] right-0 me-[15px] lg:ms-0 lg:left-auto lg:right-0 lg:me-[15px] z-[99] flex items-center justify-center rounded-full drop-shadow transition-all`}>
                            {checked &&
                                <FontAwesomeIcon icon={icon({name: 'check'})}/>
                            }
                        </div>

                        {/*{properties.icon && !properties.image &&*/}
                        {/*    <div className="absolute w-full lg:h-full text-center">*/}
                        {/*        <div className="flex flex-row w-full h-full lg:h-[240px] items-center justify-center text-[34px] pt-4 lg:pt-0 lg:text-[102px]">*/}
                        {/*            <i className={properties.icon} />*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*}*/}

                        <div
                            className={`flex w-full ${properties.image ? 'h-[50%] items-center' : 'h-full items-end'} lg:items-end relative z-50`}>
                            <div className="w-full flex flex-col">
                                <div
                                    className="w-full uppercase text-start text-[12px] lg:text-[18px] p-3 px-5 bg-[rgba(255,255,255,0.8)]">{properties.title}</div>
                                {properties.description &&
                                    <div
                                        className="hidden lg:block w-full text-start text-[12px] lg:text-[14px] pb-3 px-5">
                                        {properties.description}
                                    </div>
                                }
                            </div>
                        </div>

                        {properties.iconImage && !properties.image &&
                            <div className="absolute w-full h-full left-0 top-0 z-20">
                                <div className="w-full h-full flex flex-row items-center">
                                    <img src={properties.iconImage} width="600"
                                         className="mx-auto w-[80%] lg:w-[300px] transition-all group-hover:scale-[1.1] pointer-events-none"
                                         alt={properties.title}/>
                                </div>
                            </div>
                        }

                        {properties.image &&
                            <div className="flex flex-row items-end h-[50%]">
                                <div className="w-full h-full overflow-hidden">
                                    <img src={properties.image} width="600"
                                         className="w-full h-full object-cover transition-all group-hover:scale-[1.1] pointer-events-none"
                                         alt={properties.title}/>
                                </div>
                            </div>
                        }

                    </div>
                }
                <div className="hidden">
                    <input ref={input} type="checkbox" value="1" checked={checked} onChange={() => {
                    }}/>
                </div>
            </button>
        </Fragment>
    );
}

export default Thumb;
